import Link from 'next/link';

import { kebabCase } from '../../../utils/kebabCase';

export default function Tag({ text }: { text: string }) {
  return (
    <Link
      href={`/blog/tags/${kebabCase(text)}`}
      className="px-1 py-0.5 text-sm font-medium uppercase dark:text-[#ffd600] hover:text-opacity-75 dark:hover:text-opacity-75 bg-slate-100 dark:bg-black mr-2"
    >
      {text.split(' ').join('-')}
    </Link>
  );
}
